import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getAttendanceAll } from "src/redux/api/_hr_attendance.api";
import { AttendanceType } from "src/redux/types/_attendance.type";

export interface Filters {
  page: number;
  employee_code: string;
  name: string;
  date: string;
}

export const attendanceKeys = {
  all: ["attendance"] as const,
  list: (params: Filters) =>
    [...attendanceKeys.all, "list", params] as const,
};

export const useAttendanceHistory = (params: Filters) => {
  return useQuery<AttendanceType[]>({
    queryKey: attendanceKeys.list(params),
    queryFn: () => getAttendanceAll(params),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60,
  });
};
